import browser$1 from '../../_virtual/_polyfill-node.process.js';
import { p as propTypes } from '../../_virtual/index.js';
import './node_modules/react-is/index.js';
import factoryWithTypeCheckers from './factoryWithTypeCheckers.js';
import factoryWithThrowingShims from './factoryWithThrowingShims.js';
import { r as reactIs } from '../../_virtual/index3.js';

if (browser$1.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

export { PropTypes as default };
